import { render, staticRenderFns } from "./bachelor.vue?vue&type=template&id=a341cf54&"
import script from "./bachelor.vue?vue&type=script&lang=js&"
export * from "./bachelor.vue?vue&type=script&lang=js&"
import style0 from "./bachelor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports